import { CSSProperties } from 'styled-components';

export const getIconStyle = (): CSSProperties => ({
  display: 'flex',
  height: 12,
  width: 12,
  top: `calc(50% - 7px)`,
  transform: `translateX(-10px)`,
});

export const getListSubHeaderStyle = (): CSSProperties => ({
  pointerEvents: 'none',
});
